import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getIdToken } from "../../auth";
import {
  IDocuments,
  IPaging,
  IDownloading,
  IDeleted,
  IUpload,
} from "../../types/Document";
import { HttpStatus, isHttpCodeSuccess, findHttpStatusInfo } from "../../../src/Helpers/Http.commons";
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState {
  statusCode: number | null | undefined;
  response: Object | undefined;
  error: any;
}

const initialState: IState = {
  statusCode: null,
  response: undefined,
  error: null,
};


export const patchDeleteRequestDocument = createAsyncThunk(
  "patchDeleteRequestDocument",
  async ({
    id,
    data,
    repositoryName,
  }: {
    id: string;
    data: object;
    repositoryName: string;
  }) => {
    try {
      // const repositoryNameWithoutQuotes = repositoryName
      //   ? repositoryName.replace(/"/g, "")
      //   : "";
      // const repositoryName = repositoryNameWithoutQuotes;
      const token = getIdToken();
      const requestData = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/deletion-request/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (isHttpCodeSuccess(requestData.status)) {
        return {
          statusCode: requestData.status,
          response: requestData,
          error: null,
        };
      } else {
        const httpData:any = findHttpStatusInfo(requestData.status);
        const { message, title } = httpData;

        return {
          statusCode: requestData.status,
          response: title,
          error: message
        };
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error al procesar la solicitud");
    }
  }
);

const updateDeleteRequestDocumenSlice = createSlice({
  name: "updateDeleteRequestDocumenSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(patchDeleteRequestDocument.pending, (state) => {
        state.statusCode = null;
        state.response = {};
        state.error = null;
      })
      .addCase(patchDeleteRequestDocument.fulfilled, (state, action) => {
        const { statusCode, response, error } = action.payload;

        state.statusCode = statusCode;
        state.response = response;
        state.error = error;
      })
      .addCase(patchDeleteRequestDocument.rejected, (state, action) => {
        state.statusCode = 500;
        state.response = "Error en el servidor, testing",
        state.error = "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.";
      });
  },
});

export default updateDeleteRequestDocumenSlice.reducer;
